import { useState, type FormEvent } from 'react';
import { Alert, Button, PasswordInput, Stack, TextInput } from '@buildex/ui';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { coreEnv, loginFx, oidcLoginFx } from '@buildex/core';
import { $loginError, $loginPending } from './model';

/** authMode=oidc: логин и пароль спрашивает Keycloak — здесь только кнопка-редирект */
function OidcLoginButton() {
  const { t } = useTranslation();
  const [pending, login] = useUnit([oidcLoginFx.pending, oidcLoginFx]);
  return (
    <Button fullWidth mt="sm" loading={pending} onClick={() => void login()}>
      {t('login.sso')}
    </Button>
  );
}

export function LoginForm() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pending, hasError, submit] = useUnit([$loginPending, $loginError, loginFx]);

  if (coreEnv.authMode === 'oidc') {
    return <OidcLoginButton />;
  }

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    void submit({ email, password });
  };

  return (
    <form onSubmit={onSubmit}>
      <Stack gap="sm">
        {hasError ? <Alert color="red">{t('login.error')}</Alert> : null}
        <TextInput
          label={t('login.email')}
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)}
        />
        <PasswordInput
          label={t('login.password')}
          required
          value={password}
          onChange={(e) => setPassword(e.currentTarget.value)}
        />
        <Button type="submit" loading={pending} fullWidth mt="sm">
          {t('login.submit')}
        </Button>
      </Stack>
    </form>
  );
}
